var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: "20px 20px 20px" },
          },
        },
        [
          _c(
            "div",
            { staticClass: "member-benefit" },
            [
              _vm.configData.menuList.list.length
                ? _c("item-selector", {
                    attrs: {
                      isShowTitle: false,
                      configObj: _vm.configData,
                      configNme: "menuList",
                      isDiy: false,
                      isFrom: "noDiy",
                    },
                    on: { getSaveData: _vm.getSaveData },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "fixed-card",
          attrs: { "dis-hover": "", shadow: "never", bordered: false },
        },
        [
          _c(
            "div",
            { staticClass: "acea-row row-center-wrapper" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["merchant:member:benefits:save"],
                      expression: "['merchant:member:benefits:save']",
                    },
                    {
                      name: "debounceClick",
                      rawName: "v-debounceClick",
                      value: _vm.saveBenefits,
                      expression: "saveBenefits",
                    },
                  ],
                  attrs: { type: "primary", size: "small" },
                },
                [_vm._v("保存修改")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }